$(document).ready(function () {
  //header scroll to cart if found
  let cartIcon = document.getElementById("cart-icon");
  if (cartIcon) {
    cartIcon.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });
  }

  const $scrollToTopButton = $("#scrollToTopBtn");

  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
      $scrollToTopButton.css("display", "flex");
    } else {
      $scrollToTopButton.css("display", "none");
    }
  });

  $scrollToTopButton.click(function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      "slow",
    );
  });
});
